<template>
  <kst-page-export
    :catalog="ExpSearchCatalog"
    :params="searchParams"
    :search="searchData"
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :userData="userData"
      @init="handleExport_init"
    />

    <kst-check disabled
      v-model="userData.WithList"
      :label="Info.Export.List.Option.List"
    />
    <kst-check 
      v-model="userData.WithSummaryList"
      :label="Info.Export.List.Option.SummaryList"
    />
  </kst-page-export>
</template>

<script>
import ExpSearchCatalog from "../ExpSearchCatalog.js";
import Info from "../ExpInfo.js";
import Model from "../ExpModel.js";
import Services from "../../../services/Api/ExpenseServices.js";

import Export from "./ExpExL_Export.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    ExpSearchCatalog: ExpSearchCatalog,
    Info: Info,
    Model: Model,
    searchData: {
      Search: "",
      Date: null,
      PaymentTypeName: null,
      SubCategoryID: null,
      WarehouseID: null
    },
    userData: {
      WithList: true,
      WithSummaryList: true
    },
    searchParams: ["Search", "Date",  "PaymentTypeName", "SubCategoryID",
      "WarehouseID"],
    // func
    exportExcelFunc: null
  }),
  methods: {
    /*** by page ***/

    handleInit() {
      this.resetData();
    },

    handleExport(loadExport) {
      const options = this.getListOptions();
      const config = Services.getExportList(options);
      loadExport(config, this.handleExport_success);
    },
    handleExport_success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** export ***/

    handleExport_init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    },

    /*** custom ***/

    resetData() {
      this.userData.WithList = true;
      this.userData.WithSummaryList = true
    },

    getListOptions() {
      const paymentType =
        this.$kst.Search.getValue(this.searchData.PaymentTypeName, null) === null
        ? null
        : this.searchData.PaymentTypeName;

      return {
        paymenttype: paymentType,
        subcategory: this.$kst.Search.getValue(this.searchData.SubCategoryID),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.Fields
      };
    }
  }
}
</script>